import { isLocalhost } from '../helpers/utils'

function DevTool({ product }) {
    if (isLocalhost) return null

    return (
        <div className="my-2 py-2 bg-gray-100">
            <a
                target="_blank"
                href={`${process.env.NEXT_PUBLIC_BACKEND}wp-admin/post.php?post=${product.id}&action=edit`}
                rel="noreferrer">
                Edit
            </a>
            <a
                target="_blank"
                href={`https://olm-frontend.vercel.app/product/${product.slug}`}
                rel="noreferrer"
                className="ml-4">
                Show live app
            </a>
            <a
                target="_blank"
                href={`https://openlettermarketing.com/product/${product.slug}`}
                rel="noreferrer"
                className="ml-4">
                Show live site
            </a>
        </div>
    )
}

export default DevTool
